/**
 * BLOCK - HEADER - LISTENERS
 */

setupEventListenersForHeader();

// Creates the event listeners
function setupEventListenersForHeader() {
  // On change of value in the list of other products
  document.querySelectorAll('[data-action="redirect-other-product"]').forEach((element) => {
    element.addEventListener('change', redirectProduct);
  });
  
  // On clicking on a flag icon
  document.querySelectorAll('.flag-icon .header__link').forEach((element) => {
    element.addEventListener('click', redirectSite);
  });
  
  // On clicking on the search search icon
  document.querySelectorAll('[data-action="open-search"]').forEach((element) => {
    element.addEventListener('click', openSearch);
  });
}

/**
 * BLOCK - HEADER - GENERAL
 */

// Redirects to the correct product page
function redirectProduct() {
  window.location.href = event.target.selectedOptions[0].dataset.url;
}

// Redirects to the correct language
function redirectSite() {
  var flagIcon = event.target.closest('.flag-icon'),
      flagIconWrapper = flagIcon.closest('.flag-icon-wrapper');
  
  if (flagIcon.dataset.action == 'toggle-countries') {      
    event.preventDefault();
    flagIconWrapper.setAttribute('aria-expanded', flagIconWrapper.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    flagIconWrapper.classList.toggle('active');

    document.addEventListener('click', () => {
      if (event.target.closest('.flag-icon-wrapper') === null) flagIconWrapper.classList.remove('active');
    });
  }
}

// Opens the search wrapper
function openSearch() {
  var container = event.target.closest('.header__item-search'),
      wrapper = container.querySelector('.header__search-wrapper');
  
  if (window.innerWidth < 1201) {
    window.location.href = window.theme.localeRootUrl + '/search';
  } else {
    event.preventDefault();
    container.classList.add('header__item-search--expanded');
    container.closest('.header__wrapper').classList.add('header__wrapper--search');

    wrapper.addEventListener('transitionend', focusInput, { once: true });
    wrapper.addEventListener('webkitTransitionEnd', focusInput, { once: true });
    wrapper.addEventListener('oTransitionEnd', focusInput, { once: true });

    function focusInput() {
      container.querySelector('.search__input').focus();
    }
  }
}